import 'slick-carousel/slick/slick';
import utils from './lsag.utils';

const productCarousel = {
    productCarousels: $('.js-carousel'),
    pendingTrackingRequest: false,
    bindDyTracking() {
        if (!document.querySelector('.js-placeholder-dy-carousel')) {
            return;
        }
        $('body').on('click', '.js-dy-carousel-tracking a', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const redirectTo = event.currentTarget.href;
            const slotId = event.currentTarget.closest('.js-dy-carousel-item')?.dataset.slotId ?? '';
            const parentDataSet = event.currentTarget.closest('.js-dy-carousel-tracking')?.dataset;
            const variationId = parentDataSet.variationId ?? '';
            const decisionId = '';
            const eventType = 'SLOT_CLICK';

            if (!this.pendingTrackingRequest) {
                this.pendingTrackingRequest = true;
                this.trackDYEvent({decisionId, eventType, slotId, variationId}).done((data) => {
                    utils.logger.debug(`DY "SLOT_CLICK" interaction tracked: ${data}`);
                }).fail((jqXHR) => {
                    utils.logger.debug(`Could not send DY "SLOT_CLICK" tracking data: Error  ${jqXHR.status}`);
                }).always(() => {
                    this.pendingTrackingRequest = false;
                    if (redirectTo) {
                        window.location.href = redirectTo;
                    }
                });
            }
        });

        $('body').on('click', '.js-dy-carousel-tracking', (event) => {
            const variationId = event.currentTarget.dataset.variationId ?? '';
            const decisionId = event.currentTarget.dataset.decisionId ?? '';
            const eventType = 'CLICK';
            const slotId = '';

            if (!this.pendingTrackingRequest) {
                this.pendingTrackingRequest = true;
                this.trackDYEvent({decisionId, eventType, slotId, variationId}).done((data) => {
                    utils.logger.debug(`DY "CLICK" interaction tracked: ${data}`);
                }).fail((jqXHR) => {
                    utils.logger.debug(`Could not send DY "CLICK" tracking data: Error  ${jqXHR.status}`);
                }).always(() => {
                    this.pendingTrackingRequest = false;
                });
            }
        });
    },
    trackDYEvent({decisionId, eventType, slotId, variationId}) {
        return $.ajax({
            url: window.location.origin + ACC.config.encodedContextPath + '/view/ProductCarouselComponentController/trackDYInteraction',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                decisionId,
                eventType,
                slotId,
                variationId,
                serverId: utils.getCookie('_dyid_server'),
                dyId: utils.getCookie('_dyid'),
                sessionId: utils.getCookie('_dyjsession')
            })
        });
    },
    buildCarousel($carousel) {
        if (!$carousel.length) {
            return;
        }

        // SlickSlider can't handle only one item also return
        if ($carousel.find('.c-carousel__item').length === 1) {
            return;
        }
        $carousel
            .removeClass('c-carousel--not-ready')
            .on('init', function (event, slick) {
                // some hack to fix the behaviour for carousels with few elements
                if (slick.slideCount < 4) {
                    utils.logger.debug('Few products in the product carousel detected');
                    slick.originalSettings.slidesToScroll = slick.slideCount;
                    slick.originalSettings.slidesToShow = slick.slideCount;
                    slick.originalSettings.responsive[0].settings.slidesToScroll = slick.slideCount;
                    slick.originalSettings.responsive[0].settings.slidesToShow = slick.slideCount;
                }
            })
            .slick({
                arrows: true,
                prevArrow: `
                    <button class="c-carousel--prev slick-arrow btn-reset">
                        <svg class="icon icon-scroll-left-no-bg">
                            <use xlink:href="#icon-scroll-left-no-bg"></use>
                        </svg>
                    </button>
                `,
                nextArrow: `
                    <button class="c-carousel--next slick-arrow btn-reset">
                        <svg class="icon icon-scroll-right-no-bg">
                            <use xlink:href="#icon-scroll-right-no-bg"></use>
                        </svg>
                    </button>
                `,
                infinite: true,
                slidesToScroll: 4,
                slidesToShow: 4,
                speed: 300,
                dots: true,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToScroll: 2,
                            slidesToShow: 2
                        }
                    }
                ]
            });
    },
    buildCarousels() {
        this.productCarousels.each((index, element) => {
            const $element = $(element);
            if ($element.closest('#js-intersections').length) {
                utils.logger.log('Product Carousel as intersection detected');
                return;
            }
            this.buildCarousel($element);
        });
    },
    populateShowMoreButton($target, data) {
        if (!$target.length) {
            return;
        }
        const showMoreTitle = data.showmoretitle;
        const showMoreUrl = data.showmoreurl;
        const showMorePDP = data.showmorepdp;
        const showMorePDPUrl = $('.js-pdp-category-urls').data(`category-${showMorePDP}`);

        if (showMoreUrl !== '' || (showMorePDP !== '' && showMorePDPUrl !== undefined)) {
            if (showMoreTitle) {
                $target.attr('title', showMoreTitle);
            }
            $target.attr('href', showMoreUrl !== '' ? showMoreUrl : showMorePDPUrl);
            $target.removeClass('d-none');
        }
    }
};

// DOM ready
$(() => {
    productCarousel.bindDyTracking();
    const dyCarousels = $('.js-placeholder-dy-carousel');
    if (dyCarousels.length) {
        dyCarousels.each(function (index, element) {
            const dyCarousel = $(element);
            if (dyCarousel.closest('#js-intersections').length) {
                utils.logger.log('DY Carousel as intersection detected');
                return;
            }
            $.ajax({
                url: window.location.origin + ACC.config.encodedContextPath + '/view/ProductCarouselComponentController/' + dyCarousel.data('id'),
                type: 'GET'
            }).done(function (response) {
                const $wishlist = dyCarousel.closest('.js-wishlist-controller');
                const wishlistController = $wishlist.length && window.angular ? $wishlist.scope().wishlist : undefined;
                const $html = $(response);

                productCarousel.populateShowMoreButton($html.find('.js-productcarousel-showmorebutton'), element.dataset)

                if (dyCarousel.data('mode') === 'HERO') {
                    $html.removeClass('container');
                    $html.find('.c-carousel__headline').remove();
                    $html.find('.c-carousel__more-wrapper').remove();
                    $html.find('.c-carousel__wrapper').removeClass('c-carousel__wrapper');
                    $html.find('.c-carousel').addClass('c-carousel--hero-product');
                    $html.find('.c-grid').addClass('c-grid--hero-product');
                    $html.find('.c-carousel__item').addClass('c-carousel__item--hero-product');
                }

                if (wishlistController) {
                    dyCarousel.replaceWith(wishlistController.$compile($html)(wishlistController.$scope));
                } else {
                    dyCarousel.replaceWith($html);
                    utils.logger.info('SmartEdit active or Wishlist feature disabled');
                }

                // TODO: In case of problems, it is better to use the wishlist as in Algolia code
                setTimeout(function () {
                    if (wishlistController) {
                        wishlistController.$rootScope.$digest();
                    }
                    productCarousel.buildCarousel($html.find('.js-carousel-lazy'));
                    if (wishlistController) {
                        wishlistController.$rootScope.$broadcast('loadAlgoliaProductsSuccess');
                    }
                }, 1)
            }).fail(function (error) {
                utils.logger.debug("Cannot load " + dyCarousel.data('id'));
            });
        })
    }
    productCarousel.buildCarousels();
    $('.js-productcarousel-showmorebutton').each((index, element) => {
        const $element = $(element);
        const dataset = element.closest('.c-carousel__wrapper').dataset;
        productCarousel.populateShowMoreButton($element, dataset)
    });
});

export default productCarousel;
